<section class="container py-5 mt-5 mb-sm-2 mb-lg-3 mb-xl-4 mb-xxl-5">
  <h2 class="h1">{{event?.name}}</h2>
  <div class="row pb-sm-1 pb-md-4">
    <div class="col-md-8 mb-3 mb-md-0">

      <!-- Event contributions -->
      <section class="card bg-secondary border-0 mb-4">

        <div class="card-body">
          <div class="steps steps-horizontal steps-center mb-4">

            <div *ngIf="canDisplayAccountStep" class="step" [ngClass]="{'active': selectedTab === tabs.ACCOUNT}">
              <div class="step-number" ngbTooltip="Date utilizator">
                <div class="step-number-inner fs-4" [ngClass]="{'bg-light' : selectedTab !== tabs.ACCOUNT}">
                  <i class="ai-user-group"></i>
                </div>
              </div>
            </div>

            <div class="step" [ngClass]="{'active': selectedTab === tabs.CONTRIBUTION}">
              <div class="step-number" ngbTooltip="Contributie">
                <div class="step-number-inner fs-4" [ngClass]="{'bg-light' : selectedTab !== tabs.CONTRIBUTION}">
                  <i class="ai-card"></i>
                </div>
              </div>
            </div>

            <div class="step" [ngClass]="{'active': selectedTab === tabs.CONFIRMATION}">
              <div class="step-number" ngbTooltip="Confirmare">
                <div class="step-number-inner fs-4" [ngClass]="{'bg-light' : selectedTab !== tabs.CONFIRMATION}">
                  <i class="ai-check-alt"></i>
                </div>
              </div>
            </div>

          </div>

          <div *ngIf="canDisplayAccountStep && selectedTab === tabs.ACCOUNT">
            <form [formGroup]="formRegister" novalidate>
              <div class="row g-3 g-sm-4">

                <div class="col-12">
                  <a [routerLink]="['/auth/autentificare']" [queryParams]="{returnUrl: '/contributie/' + eventCode}" class="btn btn-lg btn-primary w-100 mb-4">Ai un cont GiftShare? Autentifica-te</a>
                  <h2 class="h6 text-center pt-3 pt-lg-4 mb-4">Sau introdu datele necesare pentru a procesa contributia</h2>
                </div>

                <div class="col-sm-6">
                  <label class="form-label" for="firstName">Prenume</label>
                  <input formControlName="firstName" [ngClass]="{'is-invalid': vs.hasErrors(formRegister, 'firstName')}"
                    class="form-control" type="text" placeholder="">
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(formRegister, 'firstName')">
                    {{vs.getError(formRegister, 'firstName')}}
                  </div>
                </div>
                <div class="col-sm-6">
                  <label class="form-label" for="firstName">Nume</label>
                  <input formControlName="lastName" [ngClass]="{'is-invalid': vs.hasErrors(formRegister, 'lastName')}"
                    class="form-control" type="text" placeholder="">
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(formRegister, 'lastName')">
                    {{vs.getError(formRegister, 'lastName')}}
                  </div>
                </div>
                <div class="col-sm-6">
                  <label class="form-label" for="firstName">Email</label>
                  <input formControlName="email" [ngClass]="{'is-invalid': vs.hasErrors(formRegister, 'email')}"
                    class="form-control" type="email" placeholder="">
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(formRegister, 'email')">
                    {{vs.getError(formRegister, 'email')}}
                  </div>
                </div>
                <div class="col-sm-6">
                  <label class="form-label" for="cityId">Localitate</label>
                  <ng-select formControlName="cityId" [items]="cities" [virtualScroll]="true" bindLabel="nameFormatted"
                    bindValue="id" [ngClass]="{'is-invalid': vs.hasErrors(formRegister, 'cityId')}" class="form-control"
                    placeholder="">
                  </ng-select>
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(formRegister, 'cityId')">
                    {{vs.getError(formRegister, 'cityId')}}
                  </div>
                </div>
                <div class="col-12">
                  <div *ngIf="isRegistrationOpen" class="form-check">
                    <input formControlName="canRegisterAccount"
                      [ngClass]="{'is-invalid': vs.hasErrors(formRegister, 'canRegisterAccount')}"
                      class="form-check-input" type="checkbox" id="canRegisterAccount">
                    <label class="form-check-label text-dark fw-medium" for="canRegisterAccount">Creeaza-mi un
                      cont GiftShare
                      <ng-container *ngIf="newUserBonus">cu <span class="fw-bold">{{newUserBonus}}
                          lei</span>
                        bonus de inregistrare. <a
                          href="/assets/content/regulament-oficial-campanie-bonus-inregistrare-giftshare.pdf"
                          target="_blank">Citeste regulamentul campaniei</a>
                      </ng-container>
                    </label>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(formRegister, 'canRegisterAccount')">
                      {{vs.getError(formRegister, 'canRegisterAccount')}}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="selectedTab === tabs.CONTRIBUTION">
            <form [formGroup]="form" novalidate autocomplete="off">
              <div class="row g-3 g-sm-4">

                <div class="col-sm-6">
                  <label class="form-label" for="amount">Valoare</label>
                  <div class="input-group">
                    <input formControlName="amount" [ngClass]="{'is-invalid': vs.hasErrors(form, 'amount')}"
                      class="form-control" type="number" inputmode="decimal" step="0.01" gsDecimalInput [decimal]="true"
                      [min]="1" [max]="99999" id="amount">
                    <span class="input-group-text">LEI</span>
                  </div>
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'amount')">
                    {{vs.getError(form, 'amount')}}
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label" for="note">Mesajul tau privat pentru destinatar</label>
                  <textarea formControlName="note" [ngClass]="{'is-invalid': vs.hasErrors(form, 'note')}"
                    class="form-control" rows="5" id="note"></textarea>
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'note')">{{vs.getError(form, 'note')}}
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-check">
                    <input formControlName="isAnonymous" [ngClass]="{'is-invalid': vs.hasErrors(form, 'isAnonymous')}"
                      class="form-check-input" type="checkbox" id="isAnonymous">
                    <label class="form-check-label text-dark fw-medium" for="isAnonymous">Contributia mea este anonima
                    </label>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'isAnonymous')">{{vs.getError(form,
                      'isAnonymous')}}
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <!-- Billing details -->
                  <label class="form-label" for="address">Date de facturare</label>

                  <!-- Selected address -->
                  <ng-container *ngIf="address" class="col">
                    <div class="card bg-secondary rounded-3 p-3 p-sm-4"
                      [ngClass]="{'border-danger': vs.hasErrors(form, 'address')}">
                      <div class="d-flex align-items-center pb-2 mb-1">
                        <h3 class="h6 text-nowrap text-truncate mb-0">{{(isCompanyAddress ? address.company :
                          address.firstName + ' ' + address.lastName) }}
                        </h3>
                        <span class="badge bg-opacity-10 fs-xs ms-3"
                          [ngClass]="{'bg-primary text-primary': !isCompanyAddress, 'bg-success text-success': isCompanyAddress}">Persoana
                          {{ isCompanyAddress ? 'juridica' : 'fizica'}}</span>
                        <div class="d-flex ms-auto">
                          <button (click)="onEditAddress(address)" class="nav-link fs-xl fw-normal py-1 pe-0 ps-1 ms-2"
                            type="button" data-bs-toggle="tooltip" aria-label="Edit">
                            <i class="ai-edit-alt"></i>
                          </button>
                        </div>
                      </div>
                      <p class="mb-0">
                        <ng-container *ngIf="address.street">{{address.street}}<br></ng-container>
                        {{getCity(address?.cityId)?.name || 'n/a'}},
                        {{getCity(address?.cityId)?.countyName || 'n/a'}}
                      </p>
                    </div>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'address')">{{vs.getError(form,
                      'address')}}</div>
                  </ng-container>

                  <!-- No address -->
                  <ng-container *ngIf="!address" class="col">
                    <div
                      class="card bg-secondary justify-content-center align-items-center border-dashed rounded-3 py-5 px-3 px-sm-4"
                      [ngClass]="{'border-danger': vs.hasErrors(form, 'address')}">
                      <a (click)="onEditAddress()"
                        class="stretched-link d-flex align-items-center fw-semibold text-decoration-none my-sm-3"
                        role="button">
                        <i class="ai-circle-plus fs-xl me-2"></i>
                        Adauga date de facturare
                      </a>
                    </div>
                    <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'address')">{{vs.getError(form,
                      'address')}}</div>
                  </ng-container>

                </div>

              </div>

            </form>
          </div>
          <div *ngIf="selectedTab === tabs.CONFIRMATION">
            <form [formGroup]="formConfirmation" novalidate autocomplete="off" class="">
              <div class="row g-3 g-sm-4 mt-4">
                <div class="col-md-6">
                  <dl class="row">
                    <dt class="col-sm-6">Contributia ta</dt>
                    <dd class="col-sm-6">{{form.value.amount | number:'1.2-2'}} lei</dd>

                    <dt class="col-sm-6">Mesajul tau privat pentru destinatar</dt>
                    <dd class="col-sm-6">{{form.value.note}}</dd>
                  </dl>
                </div>
                <!-- Selected address -->
                <div class="col-md-6">
                  <div class="fw-semibold text-dark mb-1">Date de facturare</div>
                  <div class="card bg-secondary rounded-3 p-3 p-sm-4">
                    <div class="d-flex align-items-center pb-2 mb-1">
                      <h3 class="h6 text-nowrap text-truncate mb-0">{{(isCompanyAddress ? address.company :
                        address.firstName + ' ' + address.lastName) }}
                      </h3>
                      <span class="badge bg-opacity-10 fs-xs ms-3"
                        [ngClass]="{'bg-primary text-primary': !isCompanyAddress, 'bg-success text-success': isCompanyAddress}">Persoana
                        {{ isCompanyAddress ? 'juridica' : 'fizica'}}</span>
                    </div>
                    <p class="mb-0">
                      <ng-container *ngIf="address.street">{{address.street}}<br></ng-container>
                      {{getCity(address?.cityId)?.name || 'n/a'}},
                      {{getCity(address?.cityId)?.countyName || 'n/a'}}
                    </p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-check">
                    <input formControlName="hasAcceptedTerms"
                      [ngClass]="{'is-invalid': vs.hasErrors(formConfirmation, 'hasAcceptedTerms')}"
                      class="form-check-input" type="checkbox" id="hasAcceptedTerms">
                    <label class="form-check-label" for="hasAcceptedTerms"><span class="text-muted"> Am citit si sunt
                        de acord cu </span><a class="fw-medium" target="_blank" [routerLink]="['/termeni-si-conditii']">
                        Termenii si conditiile
                      </a>
                    </label>
                    <div *ngIf="vs.hasError(formConfirmation, 'hasAcceptedTerms', 'required')" class="invalid-feedback">
                      Termenii si
                      conditiile trebuie citite si acceptate.</div>
                  </div>
                </div>
              </div>

            </form>
          </div>

        </div>
        <div class="card-footer d-flex flex-column flex-sm-row justify-content-between">
          <button (click)="onBackClick()" class="btn btn-secondary btn-lg mb-3 mb-sm-0"
            type="button">{{backLabel}}</button>
          <button (click)="onNextClick()" class="btn btn-primary btn-lg" type="button">{{nextLabel}}</button>

        </div>
      </section>

    </div>

    <!-- FAQ -->
    <div class="col-md-4">

      <div class="card bg-secondary border-0 mb-4">
        <div class="card-body">
          <h4 class="card-title"><i class="ai-bulb text-primary lead pe-1 me-2"></i>Informatii suplimentare</h4>
          <div ngbAccordion [closeOthers]="true">
            <div ngbAccordionItem [collapsed]="false" class="bg-light">
              <div ngbAccordionHeader>
                <button ngbAccordionButton>
                  Despre valoare
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody class="fs-sm">
                  <ng-template>
                    Introdu valoarea contributiei tale la acest eveniment, dar nu mai putin de 10 lei.
                  </ng-template>
                </div>
              </div>
            </div>
            <div ngbAccordionItem class="bg-light">
              <div ngbAccordionHeader>
                <button ngbAccordionButton>
                  Despre contributie anonima
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody class="fs-sm">
                  <ng-template>
                    Daca alegi sa faci o contributie anonima, numele tau nu va aparea in lista de contributii a
                    evenimentului.
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
  </div>
</section>
